"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.OsmosysAppVersionText = ({ version }) => {
    return version ? (react_1.default.createElement(react_1.default.Fragment, null,
        "Osmosys version:",
        ' ',
        react_1.default.createElement("code", { className: "text-white" },
            version.slice(0, 3),
            ".",
            version.slice(3, version.length).slice(0, 3)))) : (react_1.default.createElement(react_1.default.Fragment, null, "Osmosys"));
};
//# sourceMappingURL=OsmosysAppVersionText.js.map